import { throttle } from 'lodash';

export function hamburgerMenuToggle() {
  const headerHamburgerEle = document.querySelector('.js-headerHamburger');
  const headerNavEle = document.querySelector('.js-headerNav');
  const IS_OPEN = 'is-open';
  const IS_CLOSE = 'is-close';

  headerHamburgerEle.addEventListener('click', () => {
    headerHamburgerEle.classList.toggle(IS_OPEN);
    if (headerNavEle.classList.contains(IS_OPEN)) {
      headerNavEle.classList.add(IS_CLOSE);
      headerNavEle.classList.remove(IS_OPEN);
    } else {
      headerNavEle.classList.remove(IS_CLOSE);
      headerNavEle.classList.add(IS_OPEN);
    }
  });

  window.addEventListener(
    'resize',
    _.throttle(
      (e) => {
        headerNavClassRemove();
        return false;
      },
      10,
      { trailing: true, leading: true }
    )
  );

  function headerNavClassRemove() {
    const windowWidth = window.innerWidth;

    // スクロール量がkvの高さを超えたらページトップボタンを表示
    if (windowWidth > 768) {
      headerNavEle.classList.remove(IS_CLOSE);
    }
  }
}
